import { ArrowUpRight, Battery, Gauge } from "lucide-react";
import { ZOOMY } from "@/constants/zoomyIds";

const FLEET = [
  {
    id: "F-01",
    img: "https://customer-assets.emergentagent.com/job_ev-finance-showcase/artifacts/wyqwehdf_Rider%201.jpg",
    name: "Zoomy Urban",
    range: "45 km",
    top: "25 km/h",
    rent: "₹250/day",
  },
  {
    id: "F-02",
    img: "https://customer-assets.emergentagent.com/job_ev-finance-showcase/artifacts/qxztc17e_PHOTO-2026-05-28-11-12-23.jpg",
    name: "Zoomy Steady",
    range: "50 km",
    top: "25 km/h",
    rent: "₹250/day",
  },
  {
    id: "F-03",
    img: "https://customer-assets.emergentagent.com/job_ev-finance-showcase/artifacts/qmc8c8yx_PHOTO-2026-06-03-09-04-44.jpg",
    name: "Zoomy Urban",
    range: "55 km",
    top: "25 km/h",
    rent: "₹250/day",
  },
  {
    id: "F-04",
    img: "https://customer-assets.emergentagent.com/job_ev-finance-showcase/artifacts/hxi04720_PHOTO-2026-06-03-21-40-03.jpg",
    name: "Zoomy Lite",
    range: "50 km",
    top: "25 km/h",
    rent: "₹250/day",
  },
  {
    id: "F-05",
    img: "https://customer-assets.emergentagent.com/job_ev-finance-showcase/artifacts/5hisg4lq_PHOTO-2026-06-03-19-02-32.jpg",
    name: "Zoomy Lite",
    range: "40 km",
    top: "25 km/h",
    rent: "₹250/day",
  },
  {
    id: "F-06",
    img: "https://customer-assets.emergentagent.com/job_ev-finance-showcase/artifacts/59y8xqty_PHOTO-2026-05-28-14-32-28.jpg",
    name: "Zoomy Urban",
    range: "55 km",
    top: "25 km/h",
    rent: "₹250/day",
  },
  {
    id: "F-07",
    img: "https://customer-assets.emergentagent.com/job_ev-finance-showcase/artifacts/7xct5q75_PHOTO-2026-06-02-15-39-07.jpg",
    name: "Zoomy Urban",
    range: "45 km",
    top: "25 km/h",
    rent: "₹250/day",
  },
  {
    id: "F-08",
    img: "https://customer-assets.emergentagent.com/job_ev-finance-showcase/artifacts/kk4r53z7_PHOTO-2026-05-28-14-21-45.jpg",
    name: "Zoomy Urban",
    range: "50 km",
    top: "25 km/h",
    rent: "₹250/day",
  },
  {
    id: "F-09",
    img: "https://customer-assets.emergentagent.com/job_ev-finance-showcase/artifacts/axvk5fcu_PHOTO-2026-05-28-11-12-23.jpg",
    name: "Zoomy Steady",
    range: "55 km",
    top: "25 km/h",
    rent: "₹250/day",
  },
];

export const FleetShowcase = () => {
  const scrollContact = (e) => {
    e.preventDefault();
    document.getElementById("contact")?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section
      id="fleet"
      data-testid={ZOOMY.fleetSection}
      className="relative py-24 sm:py-32 border-t border-white/5"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-10">
        <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-6 mb-14">
          <div>
            <div className="font-mono text-xs uppercase tracking-[0.28em] text-lime-400 mb-5">
              // 03 — The fleet
            </div>
            <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tighter leading-[0.95] max-w-2xl">
              Real bikes. <br />
              Real riders. <span className="text-lime-400">On the road today.</span>
            </h2>
          </div>
          <p className="max-w-md text-sm sm:text-base text-slate-400 leading-relaxed">
            Every photo below is a Zoomy on active duty — owned by us, ridden by our partners,
            generating revenue every single day.
            <span className="block mt-3 text-lime-400 font-semibold">
              Flat ₹250/day · 2 battery swaps included daily.
            </span>
          </p>
        </div>

        {/* Uniform thumbnail grid */}
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-3 gap-3 sm:gap-4">
          {FLEET.map((bike) => (
            <FleetCard key={bike.id} data={bike} />
          ))}
        </div>

        <div className="mt-14 flex items-center justify-between flex-wrap gap-6 border-t border-white/10 pt-10">
          <div className="font-mono text-xs uppercase tracking-[0.2em] text-slate-500">
            Flat ₹250/day · 2 battery swaps included daily · serviced fortnightly
          </div>
          <a
            href="#contact"
            onClick={scrollContact}
            data-testid="fleet-book-cta"
            className="inline-flex items-center gap-2 text-lime-400 font-bold uppercase tracking-wider text-sm hover:gap-3 transition-all"
          >
            Book a Zoomy <ArrowUpRight className="w-4 h-4" />
          </a>
        </div>
      </div>
    </section>
  );
};

const FleetCard = ({ data }) => {
  return (
    <article
      data-testid={`fleet-card-${data.id}`}
      className="fleet-card group relative bg-[#0a0a0a] border border-white/10 hover:border-lime-400/50 transition-colors overflow-hidden flex flex-col"
    >
      {/* Image area — square, full image visible */}
      <div className="relative aspect-square bg-[#070707] overflow-hidden">
        <img
          src={data.img}
          alt={data.name}
          loading="lazy"
          className="absolute inset-0 w-full h-full object-contain fleet-img p-2 sm:p-3"
        />
      </div>

      {/* Info bar */}
      <div className="border-t border-white/10 p-3 sm:p-4 flex items-center justify-between gap-3">
        <div className="min-w-0">
          <h3 className="font-display text-sm sm:text-base font-bold tracking-tight text-white truncate">
            {data.name}
          </h3>
          <div className="mt-1 flex flex-wrap gap-x-3 gap-y-0.5 text-[9px] sm:text-[10px] uppercase tracking-wider text-slate-400 font-mono">
            <span className="flex items-center gap-1">
              <Battery className="w-3 h-3 text-lime-400" /> {data.range}
            </span>
            <span className="flex items-center gap-1">
              <Gauge className="w-3 h-3 text-lime-400" /> {data.top}
            </span>
          </div>
        </div>
        <div className="text-right shrink-0">
          <div className="font-display font-black text-lime-400 text-sm sm:text-base tracking-tight">
            {data.rent}
          </div>
          <div className="font-mono text-[8px] sm:text-[9px] uppercase tracking-[0.18em] text-slate-500 mt-0.5">
            +2 swaps
          </div>
        </div>
      </div>
    </article>
  );
};
